var _style, _defs, _path, _defs2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs3, _path13, _path14, _defs4, _path15, _path16, _defs5, _path17, _path18, _path19, _defs6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs7, _path30, _defs8, _path31, _defs9, _path32, _defs10, _path33, _defs11, _path34, _defs12, _path35, _defs13, _path36, _defs14, _path37, _defs15, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeggies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000125578722577405146860000009246458880072102532_);}\n\t.st1{fill:#406459;}\n\t.st2{clip-path:url(#SVGID_00000026879823127411252220000015956662294856952720_);}\n\t.st3{fill:#304C31;}\n\t.st4{clip-path:url(#SVGID_00000098922162522148592190000000715866451997711498_);}\n\t.st5{fill:#86BDA0;}\n\t.st6{clip-path:url(#SVGID_00000016759014224976517070000014590517673768524453_);}\n\t.st7{clip-path:url(#SVGID_00000095314331682181352680000008216579281961043390_);}\n\t.st8{clip-path:url(#SVGID_00000140004583144371648190000002946837931785322905_);}\n\t.st9{fill:#E63826;}\n\t.st10{fill:#791217;}\n\t.st11{fill:#FAC988;}\n\t.st12{clip-path:url(#SVGID_00000029759919993011588700000017635958680921519802_);}\n\t.st13{fill:#41806C;}\n\t.st14{clip-path:url(#SVGID_00000141435371671221819470000001247289939255760295_);}\n\t.st15{clip-path:url(#SVGID_00000168804949053403733830000004314363737860557981_);}\n\t.st16{clip-path:url(#SVGID_00000137850062646573241980000017517283194982030010_);}\n\t.st17{clip-path:url(#SVGID_00000122715468711426538950000009761772035682523521_);}\n\t.st18{clip-path:url(#SVGID_00000158010055160565803640000014716651096013610648_);}\n\t.st19{clip-path:url(#SVGID_00000065042908668014797650000001212366980403696557_);}\n\t.st20{clip-path:url(#SVGID_00000158714966031906275720000017552531518860932011_);}\n\t.st21{clip-path:url(#SVGID_00000003091750065787155920000012890231612149854367_);}\n\t.st22{fill:#FC672C;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3031",
    transform: "translate(195.827 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3022",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2152.2,
    y: 1331.2,
    width: 744.6,
    height: 695.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110431725495854729210000008744517440368401851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3021",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000110431725495854729210000008744517440368401851_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20153",
    className: "st1",
    d: "M2870.8,1594.4c-6.6-5.3-14.6-8.8-22.9-10.1c-5.7-0.5-11.4-1.4-17-2.7 c7.8-12.2,13.3-25.6,16.2-39.7c2.2-17.6-3.7-35.1-16.2-47.8c-20.5-22.7-49.3-23-76.9-18c1.1-30.5-8.7-62.7-44.5-65.8 c-16.1-1-32.3,0.7-47.9,5c-2.2,0.6-4.4,1.2-6.7,1.9c8.6-2.7-22.5-46.4-26.6-51.3c-24.4-29-51.5-39.4-78.1-7.1 c2.8-3.4-22.2-20.1-25.1-21.4c-9.6-3.9-20-5.7-30.4-5.2c-22,0.3-43.4,7.6-61,20.9c-3.9,3.2-32.7,43-29,44.8 c-25.9-12.2-56.5-32.6-82.3-11.7c-16.6,13.4-11.7,33.7-4.5,52.9c-2.9-7.6-27.8-2.9-32.7-1.3c-11.5,4.4-21.7,11.6-29.7,20.9 c-21.6,23.5-42.4,62.9-36.4,95.9c0.3,1.7,0.7,3.3,1.2,4.9c-15.4-3.1-31.3,1-43.3,11.1c-21.5,19.8-8.6,48.9-0.6,73 c-1.5-4.5-22,21.4-23.1,26c-6.4,26,11.1,53.5,25.8,73.3c2.4,3.1,4.6,6.3,6.6,9.7c1.6,2.9,1.8,1.3-0.2,2.4 c-6.8,3.4-14,3.7-19.8,9.4c-15.5,15.4-6.5,35.3,5.6,49.1c1.8,2,3.6,4,5.4,6c-1.9,1.1-3.7,2.5-5.3,4 c-24.1,24.9,14.2,48.9,33.7,59.2c13.5,7.1,27.6,13.1,42,17.9c6.9,2.4,60.4,11.4,60.2,9.5c1,12.3,9.9,22.5,22,25.1 c18.1,3.5,36.8-2.4,49.6-15.7c12.9-12.3,22.2-27.8,27.1-44.9c1.9-8.1,3.2-16.3,4-24.6c0.1-6.4,1-12.7,2.9-18.8 c2.1-2.3,2.9-5.4,2.3-8.4c4.1,0.5,8.3,1.8,12.2,2.3c7.7,1,15.5,1.3,23.2,1c16.6-0.6,33.2-3.2,49.8-4.2c32.5-2,65.3-2.4,97.9-2.9 c15-1,30,3,42.6,11.2c11.9,9.2,24.5,17.5,37.7,24.9c24.6,10.6,52.7,9.9,76.7-2.1c29.6-14.6,36.5-39.3,32.4-69.9 c27.2,5.1,60.2,3.4,75.1-23.2c9.9-17.6-4.3-29.7-10-44.4c2.7,7.1,29.6-16.4,32.3-20.2c6.9-10.1,10.9-21.9,11.5-34.2 C2898.4,1637.2,2889.8,1609.4,2870.8,1594.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3024",
    transform: "translate(0 0.132)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016043993617261815120000015451591963067361440_",
    d: "M2494.9,1332.1c-22,0.3-43.4,7.6-61,20.9 c-3.9,3.2-32.7,43-29,44.8c-25.9-12.2-56.5-32.6-82.3-11.7c-16.6,13.4-11.7,33.7-4.5,52.9c-2.9-7.6-27.8-2.9-32.7-1.3 c-11.5,4.4-21.7,11.6-29.7,20.9c-21.6,23.5-42.4,62.9-36.4,95.9c0.3,1.7,0.7,3.3,1.2,4.9c-15.3-3.1-31.3,1-43.2,11 c-21.5,19.8-8.6,48.9-0.6,73c-1.5-4.5-22,21.4-23.1,26c-0.9,3.7-1.4,7.6-1.4,11.4v0.2c0,22.4,14.6,44.8,27.2,61.6 c2.4,3.1,4.6,6.3,6.6,9.7c1.6,2.9,1.8,1.3-0.2,2.4c-6.8,3.4-14,3.7-19.8,9.4c-15.5,15.4-6.5,35.3,5.6,49.1c1.8,2,3.6,4,5.4,6 c-1.9,1.1-3.7,2.5-5.3,4c-24.1,24.9,14.2,48.9,33.7,59.2c13.5,7.1,27.6,13.1,42,17.9c6.9,2.4,60.4,11.4,60.2,9.5 c1,12.3,9.9,22.5,22,25.1c18.1,3.5,36.8-2.4,49.6-15.7c12.9-12.3,22.2-27.8,27.1-44.9c1.9-8.1,3.2-16.3,4-24.6 c0.1-6.4,1-12.7,2.9-18.8c2.1-2.3,2.9-5.4,2.3-8.4c4.1,0.5,8.3,1.8,12.2,2.3c7.7,1,15.5,1.3,23.2,1c16.6-0.6,33.2-3.2,49.8-4.2 c32.5-2,65.3-2.4,97.9-2.9c15-1,30,3,42.6,11.2c11.9,9.2,24.5,17.5,37.7,24.9c24.6,10.6,52.7,9.9,76.7-2.1 c29.6-14.6,36.5-39.3,32.4-69.9c27.2,5.1,60.2,3.4,75.1-23.2c9.9-17.6-4.3-29.7-10-44.4c2.7,7.1,29.6-16.4,32.3-20.2 c6.9-10.1,10.9-21.9,11.5-34.2c1.8-24-6.9-51.9-25.8-66.8c-6.6-5.3-14.6-8.8-22.9-10.1c-5.7-0.5-11.4-1.4-17-2.7 c7.8-12.2,13.3-25.6,16.2-39.7c2.2-17.6-3.7-35.1-16.2-47.8c-20.5-22.7-49.3-23-76.9-18c1.1-30.5-8.7-62.7-44.5-65.8 c-16.1-1-32.3,0.7-47.9,5c-2.2,0.6-4.4,1.2-6.7,1.9c8.6-2.7-22.5-46.4-26.6-51.3c-24.4-29-51.5-39.4-78.1-7.1 c2.8-3.4-22.2-20.1-25.1-21.4c-8.8-3.7-18.3-5.4-27.9-5.2C2496.6,1332,2495.7,1332,2494.9,1332.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065054554876314540310000015033714097076636590_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016043993617261815120000015451591963067361440_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3023",
    style: {
      clipPath: "url(#SVGID_00000065054554876314540310000015033714097076636590_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20154",
    className: "st3",
    d: "M2309.4,1911.5c-13.3,6.4-27.5,10.7-42.1,12.6l-1.6-8.7c14.5-1.7,28.5-6.1,41.5-12.8 c12.2-6.5,19.8-19.1,20-32.9l8.8-0.6c0.1,17.1-9.2,32.8-24.2,41C2311,1910.6,2310.2,1911,2309.4,1911.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20155",
    className: "st3",
    d: "M2254.8,1582.5l-7.7,4.2c-14.4-26-37.2-46.3-64.6-57.6l3.3-8.1 C2215.2,1533.1,2239.5,1554.7,2254.8,1582.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20156",
    className: "st3",
    d: "M2239.7,1709.8c-10.5-2-17.3-12.1-15.3-22.6c2-10.5,12.1-17.3,22.6-15.3 c2.6,0.5,5,1.5,7.2,3l-5.1,7.2c-4.8-3.2-11.4-1.9-14.6,3c-3.2,4.8-1.9,11.4,3,14.6c1.1,0.7,2.4,1.3,3.7,1.5L2239.7,1709.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20157",
    className: "st3",
    d: "M2352.2,1632.5c-7-10.2-4.4-24.2,5.9-31.2c7.6-5.2,17.7-5.2,25.3,0l-4.9,7.3 c-6.2-4.2-14.7-2.6-19,3.6c-3.1,4.6-3.1,10.7,0,15.3L2352.2,1632.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20158",
    className: "st3",
    d: "M2516.5,1465.2l-7.8,4.2c-9.3-17.3-30.8-23.8-48.1-14.6c-11.4,6.1-18.6,18-18.8,31 c0,0.1,0,0.3,0,0.4l-8.8,0c0-0.1,0-0.3,0-0.4c-0.7-14.8-12.7-26.6-27.5-26.9c-14.1,0.3-26.2,11.4-37.4,22.7l-6.3-6.2 c12.5-12.6,26.1-25,43.5-25.4c9.6,0,18.9,3.9,25.6,10.7c2.3,2.3,4.4,4.9,6,7.8c9.6-22.4,35.6-32.8,58-23.1 C2504.2,1449.3,2511.9,1456.3,2516.5,1465.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20159",
    className: "st3",
    d: "M2539,1399.5l-8.8-0.6c1.7-25.1,11.6-49,28.3-67.8l6.6,5.8 C2549.7,1354.3,2540.5,1376.3,2539,1399.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20160",
    className: "st3",
    d: "M2754.1,1561l-8.5-2.2c3.1-8.6,1.5-18.2-4.2-25.5c-3.3-3.1-8-4.4-12.4-3.5 c-2.9,0.4-5.4,2.3-6.6,4.9l-8.2-3.2c2.3-5.5,7.2-9.4,13.1-10.4c7.4-1.5,15.1,0.7,20.5,6C2755.6,1536.6,2758,1549.4,2754.1,1561"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20161",
    className: "st3",
    d: "M2583.5,1528.4l-8.7,1c-2.3-19.1,11.4-36.4,30.5-38.7c5.6-0.7,11.3,0,16.5,2.1l-3.2,8.2 c-13.4-5.1-28.5,1.6-33.6,15C2583.5,1519.9,2583,1524.2,2583.5,1528.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20162",
    className: "st3",
    d: "M2811.7,1811.1c-20.9-12-39.7-27.5-55.5-45.6l6.6-5.8c15.2,17.4,33.2,32.2,53.3,43.8 L2811.7,1811.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20163",
    className: "st3",
    d: "M2429.1,1700.8c-7.5,4.5-16.8,4.5-24.3,0.2l4.7-7.5c8.4,4,18.4,0.5,22.4-7.9 c0.9-1.8,1.4-3.7,1.6-5.7l8.8-0.2c-0.1,8.8-5.1,16.8-12.9,20.9L2429.1,1700.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20164",
    className: "st3",
    d: "M2699.7,1760.2l-8.6,2c-4.1-14-18.8-21.9-32.8-17.8c-0.4,0.1-0.8,0.2-1.1,0.4l-3.4-8.1 c18.2-6.7,38.4,2.7,45,20.9C2699.2,1758.5,2699.5,1759.3,2699.7,1760.2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3026",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065069601659774464960000018428192071907747469_",
    x: 2152.2,
    y: 1331.2,
    width: 744.6,
    height: 695.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054970406140262674960000015138394849067845038_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065069601659774464960000018428192071907747469_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3025",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000054970406140262674960000015138394849067845038_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20166",
    className: "st3",
    d: "M2477.8,1675.4c-11.8-0.5-23.4-2.6-34.6-6.3c-12.1-4-21.9-12.8-27.3-24.3l8.1-3.4 c4.5,9.3,12.5,16.3,22.3,19.5c10.4,3.4,21.3,5.3,32.2,5.8L2477.8,1675.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20167",
    className: "st5",
    d: "M2693.1,1645.9c-16.3,2.1-25.2-8.4-29.7-22.3c-0.7-2.2-6.3-8.9-7.3-6.5 c-2.5,7.4-5.8,14.5-9.9,21.2c-4.4,8-7.8,16.4-10.1,25.2c-7.1,17.7-16.2,34.2-24.7,51.3c-7.3,14.6-13.7,29.6-19.5,44.9 c-3.3,8.6-6.4,17.3-9.4,26.1c-2.3,6.7-4.9,17.1-12,20.7c-14.7,7.4-17.3-29.5-19.3-37.9c-4.4-18.6-7.6-37.4-10.6-56.4 c-3.2-20.2-6.9-40.4-8.1-60.7c-0.8-13.3-0.1-31.2-7.2-42.9c-0.7-1.1-2.1-1.6-3.4-1.3c-14.3,5.5-29.2,14.1-43.5,9 c-1.6-0.4-3.2,0.6-3.6,2.2c-0.1,0.2-0.1,0.5-0.1,0.7c1.4,23.8,1.9,42.3,3,66.1c1.6,19,0,38.1-4.8,56.5 c-2.1,8.8-6.9,16.8-13.7,22.9c-10,7.8-21,4.4-30.9-1.7c-10-6.1-19.1-14.1-28.5-21.1c-11.6-8.6-18.4-13.9-30.3-22.2 c-1.1-0.8-5.4,3.1-6.2,3.9c-10,9.3-14.4,15.8-29.9,18.4c-1.6,0.3-2.3,6.7-1.8,8.4c3.1,11.2-7.1,26.6-7.1,26.6 c6.6,6.3,14,11.8,21.9,16.5c27.2,11.3,52.6,26.8,75.1,45.9c24.8,21.1,45.6,46.6,61.2,75.3c8.1,16.3,14.9,33.1,20.5,50.4 c6.2,18.4,9.8,37.6,16.2,55.9c0.3,1.1,0.7,2.1,1.1,3.2c0.4,1.3,1.6,2.1,2.9,2.1c18.8,1.4,37.7,0,56-4.1 c8.5-2.2,16.5-5.7,24.7-8.5c8.7-3,17.7-4.6,26.6-6.7c13.6-3.9,26-11,36.1-20.8c9.8-6.7,16.2-17.5,17.3-29.3 c0.3-18.1-11.3-35-16.8-51.7c-6.9-20-11.7-40.7-14.1-61.8c-1.5-19.1-0.8-38.3,2.1-57.3c2-18.6,5.5-37.1,10.5-55.2 c5.6-17.3,12.6-34.1,20.9-50.2c5.3-10.6,11.8-20.2,9.5-32.5C2695.6,1646.8,2694.4,1645.9,2693.1,1645.9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3028",
    transform: "translate(24.365 39.039)"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000012430836288824908800000000318973818248818070_",
    d: "M2497.5,1568.1c-14.3,5.5-29.2,14.1-43.5,9 c-1.6-0.4-3.2,0.6-3.6,2.2c-0.1,0.2-0.1,0.5-0.1,0.7c1.4,23.8,1.9,42.3,3,66.1c1.6,19,0,38.1-4.8,56.5 c-2.1,8.8-6.9,16.8-13.7,22.9c-10,7.8-21,4.4-30.9-1.7c-10-6.1-19.1-14.1-28.5-21.1c-11.6-8.6-18.4-13.9-30.3-22.2 c-1.1-0.8-5.4,3.1-6.2,3.9c-10,9.3-14.4,15.8-29.9,18.4c-1.6,0.3-2.3,6.7-1.8,8.4c3.1,11.2-7.1,26.6-7.1,26.6 c6.6,6.3,14,11.8,21.9,16.5c27.2,11.3,52.6,26.8,75.1,45.9c24.8,21.1,45.6,46.6,61.2,75.3c8.1,16.3,14.9,33.1,20.5,50.4 c6.2,18.4,9.8,37.6,16.2,55.9c0.3,1.1,0.7,2.1,1.1,3.2c0.4,1.3,1.6,2.1,2.9,2.1c18.8,1.4,37.7,0,56-4.1 c8.5-2.2,16.5-5.7,24.7-8.5c8.7-3,17.7-4.6,26.6-6.7c13.6-3.9,26-11,36.1-20.8c9.8-6.7,16.2-17.5,17.3-29.3 c0.3-18.1-11.3-35-16.8-51.7c-6.9-20-11.7-40.7-14.1-61.8c-1.5-19.1-0.8-38.3,2.1-57.3c2-18.6,5.5-37.1,10.5-55.2 c5.6-17.3,12.6-34.1,21-50.2c5.3-10.6,11.8-20.2,9.5-32.5c-0.4-1.3-1.6-2.2-2.9-2.1c-16.3,2.1-25.2-8.4-29.7-22.3 c-0.7-2.2-6.3-8.9-7.3-6.5c-2.5,7.4-5.8,14.5-9.9,21.2c-4.4,8-7.8,16.4-10.1,25.2c-7.1,17.7-16.2,34.2-24.7,51.3 c-7.3,14.6-13.7,29.6-19.5,44.9c-3.3,8.6-6.4,17.3-9.4,26.1c-2.3,6.7-4.9,17.1-12,20.7c-14.7,7.4-17.3-29.5-19.3-37.9 c-4.4-18.6-7.6-37.4-10.6-56.4c-3.2-20.2-6.9-40.4-8.1-60.7c-0.8-13.3-0.1-31.2-7.2-42.9c-0.6-0.9-1.5-1.4-2.6-1.4 C2498,1568,2497.7,1568.1,2497.5,1568.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089554508127960656800000008323232527616252093_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000012430836288824908800000000318973818248818070_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3027",
    style: {
      clipPath: "url(#SVGID_00000089554508127960656800000008323232527616252093_)"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20168",
    className: "st1",
    d: "M2689.4,1924.7c-22.2-13.8-53.1-16.2-84.6-6.5c-29.4,9.1-55.6,26.5-75.6,50l-6.7-5.7 c21-24.8,48.7-43.1,79.8-52.7c34-10.4,67.5-7.7,91.9,7.4L2689.4,1924.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20169",
    className: "st3",
    d: "M2570,1833.4l-8,3.7c-16.4-35.3-25.1-73.6-25.8-112.5l8.8-0.1 C2545.7,1762.1,2554.2,1799.2,2570,1833.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000159470644289301122380000017471538864729957551_",
    x: 2152.2,
    y: 1331.2,
    width: 744.6,
    height: 695.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145027551923972621870000005741164266863323298_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159470644289301122380000017471538864729957551_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3029",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000145027551923972621870000005741164266863323298_)"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20171",
    className: "st3",
    d: "M2311.5,1799.8c-5.7,3.2-12.2,4.8-18.7,4.6l0.5-8.8c11.4-0.2,21.9-6.5,27.3-16.6 c5.6-10.7,8.5-22.6,8.6-34.7l0.2-3.7l3.7-0.5c25.3-4.5,42.1-28.6,37.7-53.9c-0.1-0.8-0.3-1.6-0.5-2.3l8.5-2.4 c3.9,14.9,1.1,30.7-7.6,43.4c-7.6,11.9-19.5,20.3-33.3,23.4c-0.4,12.4-3.7,24.5-9.6,35.3 C2324.1,1790.4,2318.3,1796,2311.5,1799.8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20172",
    className: "st3",
    d: "M2574.8,1636.1c-0.6,0.4-1.3,0.7-2,1c-8.4,4-18,4.5-26.8,1.4 c-12.3-5.1-21.7-15.4-25.7-28.1c-12.3,12.4-30.5,16.9-47.1,11.7c-15.8-5.2-26.9-18.2-36.9-31l6.9-5.4 c9.2,11.8,19.3,23.6,32.8,28.1c16.1,4.8,33.5-1.4,42.8-15.4l6.3-10.1l1.8,11.7c1.5,13.3,10,24.9,22.3,30.3 c6.5,2.3,13.7,1.9,19.9-1.1c5-2.2,9-6.3,10.9-11.5l8.3,2.9C2585.9,1627.3,2581,1632.9,2574.8,1636.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20173",
    className: "st3",
    d: "M2758.7,1682.4c-5.7,3.2-12.1,5-18.6,5.3c-17.5,0.5-33.7-9.5-41-25.4 c-1.4-3.2-2.2-6.7-2.1-10.2c-2.6,0.3-5.2,0.2-7.7-0.2c-10.6-2.1-20-8.3-26-17.4c-2.6-3.9-4.8-8.1-6.5-12.5 c-5.9,13.2-14.5,25.1-25.3,34.8c-14,12.9-33.3,18.6-52.1,15.3l1.9-8.6c16.1,2.7,32.5-2.2,44.4-13.3 c12.2-11.5,21.6-25.7,27.3-41.5l4.4-10.9l3.8,11.1c2.2,7.3,5.4,14.2,9.4,20.7c4.7,7,11.9,11.9,20.1,13.6 c3.7,0.7,7.6,0.1,10.9-1.7c0.7-0.5,1.4-1,2.2-1.4l4.7,7.4c-0.5,0.4-0.9,0.7-1.4,1c-1.7,3.2-1.6,7,0.2,10.2 c7.7,17.2,27.9,24.9,45.1,17.2c8.6-3.8,15.2-11.1,18.3-19.9l8.3,2.9C2775.3,1668.9,2768.2,1677.2,2758.7,1682.4"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3033",
    transform: "translate(143.996 114.045)"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137130758513752117010000008471282980118679191_",
    x: 1837.9,
    y: 2022.8,
    width: 420.5,
    height: 419.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116209298430204348150000004884447781317284527_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137130758513752117010000008471282980118679191_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3032",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000116209298430204348150000004884447781317284527_)"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20174",
    className: "st1",
    d: "M2063.3,2034.5c-9.9,13.8-20.4,27.3-29.6,41.6c-4.2,6.6-8.5,13.2-12.1,20.1 c-2.9,5.8-5.4,11.8-7.5,18c-2.5-11.8-1.9-24.1-4.5-35.9c-3.8-17.5-12-33.8-15.3-51.5c-0.8-2.9-3.7-4.6-6.6-3.9 c-2.3,0.6-3.9,2.6-4,4.9c-1,27,1,54,5.9,80.6c0.6,3,1.1,6.1,1.4,9.2c-0.1-4-10-9.2-12.6-11.7c-5.1-4.9-10.2-9.9-15.4-14.8 c-12-12.1-25.3-22.9-39.4-32.3c-6.3-3.9-10,4.7-5.8,9.1c13.6,14.5,22.7,32.6,34.9,48.3c13.1,17.4,28.3,33,45.4,46.5 c4.4,4.4,11.1,5.5,16.6,2.7c5.6-3.6,10.3-8.6,13.7-14.3c15-24.2,26.7-50.2,35-77.4c4-11.4,7.2-23,9.8-34.7 c0.8-2.9-0.9-5.9-3.8-6.7C2067,2031.7,2064.6,2032.6,2063.3,2034.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20175",
    className: "st9",
    d: "M2201.8,2081.4c-78.4-42.3-152.3,59.8-229.6,57.3c-49.1-1.6-89.6,10.4-112.8,56.2 c-26.5,52.3-32.8,133.1,6.1,181.1c64,79,208.9,83.8,289.9,33c49.5-30.9,84.4-80.6,96.6-137.7c11.5-54.2,11.5-136.6-32.4-177.2 C2214.2,2089.3,2208.3,2085,2201.8,2081.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20176",
    className: "st10",
    d: "M2059,2299.3c-5.6-1.9-11.7-1.4-16.9,1.3c-9.7,4.5-14.3,11.3-24.9,6.6 c-7.2-4.4-12.5-11.2-15.1-19.2c-4.9-11.6,0.4-21.1,5.8-32.3c18.6-38.6-14.9-79.4-61.4-63.3c-22.9,7.8-40.1,26.9-45.3,50.5 c-10.7,46.2,3.7,94.6,38,127.3c25.9,24.5,61.1,36.7,96.6,33.5c14.8-1.5,30.1-5.9,39.1-17.9c6.8-9.8,10.7-21.3,11.1-33.2 c0.9-17.7-4.6-45.1-24.6-52C2060.6,2300.1,2059.8,2299.6,2059,2299.3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20177",
    className: "st10",
    d: "M2149.5,2133.2c-3.5-0.7-7.1-1.2-10.7-1.4c-22.7-1.6-64.9-1.1-80.2,19.9 c-9.7,13.4-12.9,49.8-3.5,62c12,15.5,37.2,3.5,52,14.3c14.9,10.9,5.2,29-3,42.1c-13.1,20.9,8.8,51.2,24.7,63.3 c20.5,15.7,46,13.1,62.7-9.8c32.2-44,28.7-103.7,10.5-147.5C2193.2,2153.6,2173.3,2137.4,2149.5,2133.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20178",
    className: "st11",
    d: "M1979.9,2228c-6.7-7.9-15.4-19-26.9-13c-2.2,1.5-3.2,4.3-2.4,6.8 c1.8,4.4,5.3,7.8,9.7,9.5c3.9,1.2,7.5,3,10.9,5.2c2.6,2.1,6.4,1.7,8.5-0.9c1.3-1.6,1.7-3.6,1.1-5.5 C1980.7,2229.3,1980.4,2228.6,1979.9,2228"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20179",
    className: "st11",
    d: "M1971.7,2302.9c-10.8,3.8-25.9,12.2-24,25.8c0.5,3.9,3.8,6.7,7.7,6.5 c11.8,0.3,19.9-12.2,24.7-21.4v-0.1c2.1-3.5,1-8-2.5-10.1C1975.8,2302.5,1973.6,2302.2,1971.7,2302.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20180",
    className: "st11",
    d: "M2039.6,2344.9c-0.6-1.4-1.5-2.6-2.8-3.4c-3.4-4.9-12.3-4.9-12.8,2.3 c-0.7,10.7-4.6,20.6,0.5,30.9c1.2,3,4.1,4.8,7.3,4.6C2049.9,2377.1,2044.4,2356.4,2039.6,2344.9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20181",
    className: "st11",
    d: "M2087.9,2161.1c-9.8,3.1-6.1,17.5-3.7,24.5c2.2,2.4,5.2,3.9,8.5,4.1 c3.2-0.2,5.7-3,5.7-6.2c-0.1,2.2,0.2-0.8,0.2-1.3c0.2-1.1,0.3-2.2,0.5-3.2c0.5-2.7,0.6-5.5,0.5-8.2 C2099.1,2164.7,2094.6,2158.9,2087.9,2161.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20182",
    className: "st11",
    d: "M2166.9,2204.6c-9.2-1.6-18.5,1.8-24.5,8.9c-3.6,2.3-4.6,7.1-2.3,10.6 c0.6,1,1.5,1.8,2.5,2.5c11.6,6.5,29.8-2.1,30.1-15.6C2172.4,2207.8,2170,2205.2,2166.9,2204.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20183",
    className: "st11",
    d: "M2147.1,2273.1L2147.1,2273.1c-3.5,0.9-5.5,4.5-4.6,7.9c0.1,0.3,0.2,0.7,0.4,1 c4,9.6,20.7,28.3,30.6,14.9C2183.3,2283.6,2159.4,2263,2147.1,2273.1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3050",
    transform: "translate(0 50.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3035",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000077290198579178770770000011579034464240444862_",
    x: 964.7,
    y: 1636.2,
    width: 664.2,
    height: 869.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088129903084056011010000005587349987271045304_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077290198579178770770000011579034464240444862_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3034",
    style: {
      clipPath: "url(#SVGID_00000088129903084056011010000005587349987271045304_)"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20184",
    className: "st13",
    d: "M1112.1,1989.4c8.3-8.4,19.9-12.9,27-22.5c8.1-11.7,12.9-25.4,13.7-39.6 c-0.4-14.9-2.3-29.6-5.9-44.1c-2.4-14-2.2-28.3-5.2-42.2c-2.4-11.3-8.2-21.6-16.7-29.6c-18-17-41.3-27.3-66-29.3 c-24.1-1.7-51.8,5.9-67.7,25.2c-7,9.4-12,20.2-14.6,31.6c-3.7,12.7-7.9,25.5-10.4,38.5c-5.4,27.8,3.7,53.8,13.4,79.6 c5.3,14.1,14.6,20.1,27.7,26.3c15.5,6.5,30.4,14.5,44.4,23.9c11.2,8.3,14.5,19,19.4,31.5c2.8,9.7,9,18.1,17.4,23.7 c0.6,0.5,1.3,0.8,2,1c0.2,0.1,0.3,0.1,0.5,0.2c1.6,0.7,3.4,0.6,4.9-0.2c13.6-2.7,7.2-27.6,6.1-37.2 C1099.5,2013,1103.1,1999.4,1112.1,1989.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3037",
    transform: "translate(0 20.619)"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000179605222105120440920000016373421781883952818_",
    d: "M991.3,1786.7c-7,9.4-11.9,20.2-14.6,31.6 c-3.7,12.7-7.9,25.5-10.4,38.5c-1.1,5.5-1.6,11.2-1.6,16.8v0.5c1.2,21.5,6.3,42.6,15,62.3c5.3,14.1,14.6,20.1,27.7,26.3 c15.5,6.5,30.4,14.5,44.4,23.9c11.2,8.3,14.5,19,19.4,31.5c2.8,9.7,9,18.1,17.4,23.7c0.6,0.5,1.3,0.8,2,1 c0.2,0.1,0.3,0.1,0.5,0.2c1.6,0.7,3.4,0.6,4.9-0.2c13.6-2.7,7.2-27.6,6.1-37.2c-2.6-13.1,1-26.8,9.9-36.8 c8.3-8.4,19.9-12.9,27-22.5c8.1-11.7,12.9-25.4,13.7-39.6c-0.4-14.9-2.3-29.6-5.9-44.1c-2.4-14-2.2-28.3-5.2-42.2 c-2.4-11.3-8.2-21.7-16.7-29.6c-18-17-41.3-27.3-66-29.3c-2.2-0.1-4.4-0.2-6.6-0.2C1030,1761.2,1005.7,1769.1,991.3,1786.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111904882910095930650000011403470734535880601_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179605222105120440920000016373421781883952818_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3036",
    style: {
      clipPath: "url(#SVGID_00000111904882910095930650000011403470734535880601_)"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20185",
    className: "st3",
    d: "M1110.8,2067.5h-13.4c-1-13.8-4.6-27.2-10.6-39.6c-2.2-5.5-4.5-11.2-6.5-17 c-4.2-13.6-7.4-27.5-9.6-41.6c-2.2-15.5-6-30.8-11.2-45.5c-1.5-3.9-3.3-7.8-5.1-11.8c-5.4-10.3-9-21.4-10.7-32.8l13.4-1.3 c1.6,10,4.9,19.6,9.6,28.6c1.8,4,3.7,8.2,5.4,12.5c5.6,15.6,9.6,31.7,12,48c2.1,13.4,5.1,26.7,9.1,39.7c1.8,5.4,4,10.9,6.2,16.2 C1106,2036.8,1109.9,2051.9,1110.8,2067.5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3039",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098916917630111918690000009430193185021357487_",
    x: 964.7,
    y: 1636.2,
    width: 664.2,
    height: 869.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103225392432868731790000014186096378820044686_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098916917630111918690000009430193185021357487_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3038",
    style: {
      clipPath: "url(#SVGID_00000103225392432868731790000014186096378820044686_)"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20187",
    className: "st13",
    d: "M1219,1910.9c3,9.2,5.3,18.7,6.9,28.3c4.4,19.4,6.6,39.2,6.6,59.1 c-1.2,22.4-11.8,42.2-20.2,62.6c-3.8,9.3-7.9,18.2-12.2,27.2c-4.4,7.8-6.8,16.6-6.8,25.5c0,0.2,0,0.4,0.1,0.6 c-0.3,1.3-0.6,2.5-0.9,3.8c-0.9,3.2,0.9,6.5,4.1,7.4c0.9,0.3,1.9,0.3,2.8,0.1c13.2-2.8,19.6-19.7,25.1-30.4 c10.1-19.9,18.8-40.5,29.9-59.8c10-18.4,23.4-34.6,39.5-47.9c15-11.9,31.8-21.2,47.5-32.1c16-10.7,29.7-24.4,40.3-40.4 c12-18.3,22.3-37.5,34.1-55.9c12.1-17.3,21.6-36.3,28.2-56.4c4.9-18.4,6.8-37.4,5.5-56.3c-0.9-17.9-8.2-33.7-15-50 c-7-16.7-12.2-31.1-26.8-42.7c-11.7-10.5-26.6-16.7-42.3-17.4c-18,0.4-29.5,11.3-40.4,24.5c-26.5,31.9-45,70.6-65.8,106.3 c-11.2,19.3-22.1,38.7-31.4,59c-9.3,17.9-14.4,37.6-14.8,57.7C1213.7,1893,1215.7,1902.2,1219,1910.9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3041",
    transform: "translate(32.229 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174569794239922498370000002858831674110521494_",
    d: "M1333.9,1636.2h-0.7c-18,0.4-29.5,11.3-40.4,24.5 c-26.5,31.9-45,70.6-65.8,106.3c-11.2,19.3-22.1,38.7-31.4,59c-9.3,17.9-14.4,37.6-14.8,57.7c0.8,9.3,2.8,18.4,6.1,27.1 c3,9.2,5.3,18.7,6.9,28.3c4.4,19.4,6.6,39.2,6.6,59.1c-1.2,22.4-11.8,42.2-20.2,62.6c-3.8,9.3-7.9,18.2-12.2,27.2 c-4.4,7.8-6.8,16.6-6.8,25.5c0,0.2,0,0.4,0.1,0.6c-0.3,1.3-0.6,2.5-0.9,3.8c-0.9,3.2,0.9,6.5,4.1,7.4c0.9,0.3,1.9,0.3,2.8,0.1 c13.2-2.8,19.6-19.7,25.1-30.4c10.1-19.9,18.8-40.5,29.9-59.8c10-18.4,23.4-34.6,39.5-47.9c15-11.9,31.8-21.2,47.5-32.1 c16-10.7,29.7-24.4,40.3-40.4c11.9-18.3,22.3-37.5,34.1-55.9c12.1-17.3,21.6-36.3,28.2-56.4c4.9-18.4,6.8-37.4,5.5-56.3 c-0.9-17.9-8.2-33.7-15-50c-7-16.7-12.2-31.1-26.8-42.7c-11.4-10.2-25.9-16.3-41.1-17.4H1333.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080170615727535323840000009206467512823767957_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174569794239922498370000002858831674110521494_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3040",
    style: {
      clipPath: "url(#SVGID_00000080170615727535323840000009206467512823767957_)"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20188",
    className: "st3",
    d: "M1153.1,2144.3l-9.6-9.4c17.1-17.7,27.3-41.1,37.1-63.7l130.5-299.9l12.3,5.4l-130.5,300 C1183.1,2099.2,1171.9,2124.9,1153.1,2144.3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3043",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000165922113136247623240000003136085016778777759_",
    x: 964.7,
    y: 1636.2,
    width: 664.2,
    height: 869.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003073478143533466730000010303491777942632619_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165922113136247623240000003136085016778777759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3042",
    style: {
      clipPath: "url(#SVGID_00000003073478143533466730000010303491777942632619_)"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20190",
    className: "st13",
    d: "M1445.1,2238.9c17.9-7.7,28.1-25.1,37.7-41.1c11.3-19,25.2-36.1,38.4-53.9 c28.9-39.2,57.1-79.6,82.3-121.3c11.5-18.7,18.9-39.5,21.8-61.3c2.4-18,7.2-39.2-0.5-56.5c-7.4-15.2-22.4-25.2-39.2-26.1 c-18.4-1.6-36.7,5.8-53,13.2c-18.2,7.8-35.3,18.3-50.6,30.9c-15.6,13.9-30.1,29-43.5,45.1c-14.8,17.3-31.5,32.8-49.7,46.5 c-18.4,13.8-38.8,25.9-55.4,41.8c-31.7,30.5-44.6,77-45.5,120c0.1,11.2,0.9,22.4,2.4,33.5c1.1,9.9,4.3,19.6,5,29.4 c0.7,9.2-5.9,17.6-10.9,24.6c-5.7,7.9-11.1,15.7-16.4,23.9l-19.2,30l-0.6,0.4c-2.9,1.6-3.9,5.2-2.3,8.1c0.7,1.3,1.9,2.3,3.3,2.8 c9.8,4.2,17.4-4.7,22.6-13.3c1.5-1.3,3-2.7,4.3-4.2c5.2-5.8,9.6-12.3,14.1-18.5c4.8-7,10.2-13.5,16.1-19.6 c5.7-5.4,13.5-8,21.3-6.9c19.6,1.3,39.4-0.8,58.3-6.2c9.6-3.1,18.5-7.6,27.9-11.1C1424.1,2245.1,1435,2243.3,1445.1,2238.9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3045",
    transform: "translate(39.693 34.285)"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000117656836807064897890000012796579236347322037_",
    d: "M1492.8,1857.5c-18.2,7.8-35.3,18.3-50.6,30.9 c-15.6,13.9-30.1,29-43.5,45.1c-14.8,17.3-31.5,32.8-49.7,46.5c-18.4,13.8-38.8,25.9-55.4,41.8c-31.7,30.5-44.6,77-45.5,120 c0.1,11.2,0.9,22.4,2.4,33.5c1.1,9.9,4.3,19.6,5,29.4c0.7,9.2-5.9,17.6-10.9,24.6c-5.7,7.9-11.1,15.7-16.4,23.9l-19.2,29.9 l-0.6,0.4c-2.9,1.6-3.9,5.2-2.3,8.1c0.7,1.3,1.9,2.3,3.3,2.8c9.8,4.2,17.4-4.7,22.6-13.3c1.5-1.3,3-2.7,4.3-4.2 c5.2-5.8,9.6-12.3,14.1-18.5c4.8-7,10.2-13.5,16.1-19.6c5.7-5.4,13.5-8,21.3-6.9c19.6,1.3,39.4-0.8,58.3-6.2 c9.6-3.1,18.5-7.6,27.9-11.1c10.2-3.9,21.2-5.7,31.3-10.1c17.9-7.7,28.1-25.1,37.7-41.1c11.3-19,25.2-36.1,38.4-53.9 c28.9-39.2,57.1-79.6,82.3-121.3c11.5-18.7,18.9-39.5,21.8-61.3c2-11.1,3.2-22.4,3.7-33.7v-0.4c0.2-7.7-1.3-15.3-4.2-22.4 c-7.4-15.2-22.4-25.2-39.2-26.1c-1.7-0.1-3.4-0.2-5.1-0.2C1524,1845.2,1507.6,1849.8,1492.8,1857.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150817615430734582420000014560516041949464746_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117656836807064897890000012796579236347322037_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3044",
    style: {
      clipPath: "url(#SVGID_00000150817615430734582420000014560516041949464746_)"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20191",
    className: "st3",
    d: "M1217.1,2295l-11.5-7c63.2-103.8,136.4-201.2,218.5-290.8l9.9,9.1 C1352.5,2095.3,1279.9,2192,1217.1,2295"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3047",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114047063294443218740000008350325817647164602_",
    x: 964.7,
    y: 1636.2,
    width: 664.2,
    height: 869.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000076598747575380198020000005414070906861860535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114047063294443218740000008350325817647164602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3046",
    style: {
      clipPath: "url(#SVGID_00000076598747575380198020000005414070906861860535_)"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20193",
    className: "st13",
    d: "M1172.8,2238.4c-8.3-22.3-22.8-41.8-41.8-56.1c-16-13.8-35.9-22.2-56.9-24.1 c-21.3-0.5-40.9,11.5-50.3,30.6c-7.7,16-13.3,33-16.8,50.4c-4.1,16.8-10,33.1-13.9,50c-4.6,17.5-5.3,35.9-2.2,53.7 c4.8,17.5,12.1,34.1,21.7,49.5c9.4,15.2,13.8,32.9,12.8,50.7c-1.7,17.2-6.4,33.6-4.5,51c0.1,2.7,2.4,4.7,5,4.6 c0.3,0,0.7-0.1,1-0.1c7.2,3.4,13-6.8,15.5-12.2c4.6-9.7,8-19.7,12.9-29.1c3.6-7.7,8.3-15,13.7-21.5c6.3-6.2,13.8-11.1,22.1-14.3 c15.3-6.2,29.4-14.9,41.7-25.9c20.5-21.1,34.7-47.5,41.2-76.2C1181.6,2292.8,1181.1,2264.7,1172.8,2238.4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3049",
    transform: "translate(3.438 73.892)"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170999221876924108190000015446262803366998704_",
    d: "M1020.5,2114.9c-7.7,16-13.3,33-16.8,50.4 c-4.1,16.8-10,33.1-13.9,50c-4.6,17.5-5.3,35.9-2.2,53.7c4.8,17.5,12.1,34.1,21.7,49.5c9.4,15.2,13.8,32.9,12.8,50.7 c-1.7,17.2-6.4,33.6-4.5,51c0.1,2.7,2.4,4.7,5,4.6c0.3,0,0.7-0.1,1-0.1c7.2,3.4,13-6.8,15.5-12.2c4.6-9.7,8-19.7,12.9-29.1 c3.6-7.7,8.3-15,13.7-21.5c6.3-6.2,13.8-11.1,22.1-14.3c15.3-6.2,29.4-14.9,41.7-25.9c20.5-21.1,34.7-47.5,41.2-76.2 c7.5-26.5,7-54.6-1.3-80.9c-8.3-22.3-22.8-41.8-41.8-56.1c-16-13.8-35.9-22.2-56.9-24.1c-0.7,0-1.3,0-1.9,0 C1048.2,2084.6,1029.5,2096.4,1020.5,2114.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165933043862306760870000002939205000140081584_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170999221876924108190000015446262803366998704_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3048",
    style: {
      clipPath: "url(#SVGID_00000165933043862306760870000002939205000140081584_)"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20194",
    className: "st3",
    d: "M1030.3,2432.2l-12.8-4.2c17.8-49.8,31.1-101.1,39.9-153.2c3.8-21.4,4.2-43.3,1.1-64.9 l13.2-2.4c3.3,23,3,46.4-1.1,69.2C1061.8,2329.7,1048.3,2381.7,1030.3,2432.2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3052",
    transform: "translate(125.506 2.357)"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000073705176777398402390000013266268959770768771_",
    x: 1725.8,
    y: 1345.5,
    width: 332.9,
    height: 400.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022541241274092266720000002555278560845013142_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000073705176777398402390000013266268959770768771_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3051",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000022541241274092266720000002555278560845013142_)"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20196",
    className: "st3",
    d: "M2052.6,1347.2c-7.8-2.5-16.3-1.7-23.5,2.3c-8.2,4.2-15.3,10.1-20.9,17.5 c-6.3,8.9-11.9,18.4-16.6,28.3c-4.3,7.8-8.9,15.4-12.9,23.4c-1.4,2.8-2.8,5.7-4.1,8.6c-0.9,2.1-2.3,4.7-1.3,6.9 c1.1,2.2,4.3,3,6.4,4.2c2.9,1.8,5.8,3.5,8.9,4.9c4,1.6,8.3,2.1,12.5,1.6c7-0.8,18.3,0.1,19.8-8.9c0.4-3.9,0.1-7.9-0.7-11.7 c-0.8-5.7-0.8-11.4-0.1-17c0.8-11.9,7.4-22.7,17.6-29c6.4-3.5,15.1-3.5,18.9-10.6C2060.7,1360.6,2058.9,1351.9,2052.6,1347.2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20197",
    className: "st22",
    d: "M2020.2,1440.3c-20.4-20-49.2-29-77.4-24.1c-14.1,2.6-27.2,9-37.9,18.6 c-12.2,12.5-21.4,27.6-27.1,44.1c-7.4,20.1-16.4,39.6-27,58.2c-11.8,19-21.7,39.7-36.5,56.7c-9.1,9.7-19,18.6-29.4,26.9 c-10.5,8.9-20.5,18.3-29.9,28.2c-16.6,17.8-33.7,42-28.3,67.8c1.1,5.2,3,10.2,5.7,14.8c-0.3,2.4,0.9,4.7,3,5.9 c30.2,16.4,60.9,6.2,89.7-7.8c37.2-18.2,75.2-35.3,108.8-59.9c26.2-19.6,49.8-42.5,70.1-68.2c18.7-23.4,35.3-50.5,40.5-80.4 C2050.2,1491.7,2041.1,1461.6,2020.2,1440.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeggies);
export default __webpack_public_path__ + "static/media/veggies.77fb1fd5621a2f2aa5506b86d1d5f1f6.svg";
export { ForwardRef as ReactComponent };